import { createPlugin } from '../../registerComponent';
import MtIcon from './MtIcon';
export var MtIconPlugin = createPlugin(MtIcon);
export { MtIcon };
//# sourceMappingURL=index.js.map